import { PrivacyPolicySignStatusDto } from '@/api/generated/models/privacy-policy-sign-status-dto';
export const isPrivacyPolicySigningRequired = (privacyPolicyStatus: PrivacyPolicySignStatusDto) => {
  return ![
    PrivacyPolicySignStatusDto.NotRequired,
    PrivacyPolicySignStatusDto.SignedMostRecent,
  ].some(status => status === privacyPolicyStatus);
};
